export class Account {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    password:string;
    password_confirmation: string;
    sub_until: any;
    display_name: string;
    required_points:number;
    constructor(account?) {
        if (account) {
            this.id = account.id;
            this.first_name = account.first_name;
            this.last_name = account.last_name;
            this.email = account.email;
            this.password = account.password;
            this.password_confirmation  = account.password_confirmation;
            this.sub_until = account.sub_until;
            this.display_name = account.display_name;
            this.required_points = account.required_points;
        }
    }
}
